var _path;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFacebookFaded(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 89,
    height: 90,
    viewBox: "0 0 89 90",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 45.3283C0 67.2928 15.9524 85.5573 36.8162 89.261V57.3525H25.7713V45.0816H36.8162V35.2628C36.8162 24.2179 43.9327 18.0843 53.9983 18.0843C57.1866 18.0843 60.6252 18.574 63.8135 19.0636V30.3552H58.1695C52.7686 30.3552 51.5426 33.0538 51.5426 36.4924V45.0816H63.3238L61.3615 57.3525H51.5426V89.261C72.4064 85.5573 88.3588 67.2965 88.3588 45.3283C88.3588 20.8934 68.4781 0.902222 44.1794 0.902222C19.8807 0.902222 0 20.8934 0 45.3283Z",
    fill: "black",
    fillOpacity: 0.3
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebookFaded);
export default __webpack_public_path__ + "static/media/facebook-faded.90dc89b180074edf90724ba8016a0a51.svg";
export { ForwardRef as ReactComponent };